import React from 'react';
import {
  Box,
  Divider,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { whatsAppSettingSchema } from '../../helpers/validations/forgotPasswordValidation';
import { CreateWhatsAppSetting } from '../../api/SchoolService/SchoolService';
import { useSnackbar } from '../../components/MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import Button from '../../components/Button/Button';
import useRequestLock from '../../hooks/useRequestLock';
import '../../styles/layout/_mainLayout.scss';
import { useAuth } from '../../hooks/useAuth';

const WhatsAppSetting = () => {
  const theme = useTheme();
  const { user } = useAuth()
  const { loading: requestLoading, execute } = useRequestLock();
  const isDark = theme.palette.mode === 'dark';
  const [position, setPosition] = React.useState(50);
  const { showSnackbar } = useSnackbar();

  const {
    register,
    handleSubmit,
    reset,
    watch, 
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(whatsAppSettingSchema),
    defaultValues: {
      token: "",
      phoneNumberId: ""
    }
  
  });

  const saveWhatsAppSetting = async data => {
    try {

      const formWhatsAppForm = new FormData();
      formWhatsAppForm.append("SchoolID", user.schoolID);
      formWhatsAppForm.append("PhoneNumberId", data.phoneNumberId);
      formWhatsAppForm.append("AccessToken", data.token);
      const response = await CreateWhatsAppSetting(formWhatsAppForm);
      if(response.success === false || response.error === true){
        showSnackbar(response.message || `Failed! please try agian after some time`, 'info');
        return 
      }
      reset({
        token: "",
        phoneNumberId: "",
      });
      showSnackbar("WhatsApp configuration applied successfully", 'success');
    } catch (err) {
      showSnackbar(err.message || 'Something went wrong. Please try again.', 'error');
    }
  };

  const onSubmit = data =>
    execute('saveWhatsAppSetting', async () => {
      await saveWhatsAppSetting(data);
    });

  const onFormError = formErrors => {
    const firstError = Object.values(formErrors)[0];
    if (firstError?.message) {
      showSnackbar(firstError.message, 'error');
    }
  };

  return (
    <>
      <Box
        position={'relative'}
        sx={{ backgroundImage: 'linear-gradient(120deg,#edf7f3,#fff5e8)' }}
      >
        <Box
          display={'flex'}
          alignItems={'center'}
          minHeight={`calc(100vh - 68px)`}
          width={'100%'}
          zIndex={1}
          position={'relative'}
        >
          <Box
            display={'flex'}
            justifyContent={{ xs: 'center', sm: 'center', md: 'center', lg: 'center' }}
            px={{ xs: 2, sm: 3, md: 4, lg: 5 }}
            flexWrap={'wrap'}
            width={'100%'}
            gap={{ xs: 2, sm: 3, md: 3, lg: 3 }}
          >
            <Box
              className=" portal-card"
              width={{ xs: '100%', sm: 500, md: 300, lg: 380, xl: 500 }}
            >
              <Box>
                <Box
                  className="dashboard-card form_card"
                  border={'solid 1px #e2e8f0'}
                  px={2}
                  py={3}
                  height={'100%'}
                >
                  <Box textAlign={'center'} mb={4}>
                    <Typography variant="h6" mb={1} className="card-title text-center">
                      Apply for WhatsApp Message Setting?
                    </Typography>
                    <Typography variant="body2" align="center" color="rgba(0,0,0,0.6)">
                      Enter whatsapp business account token and Phone number id implement this.
                    </Typography>
                  </Box>
                  <Box mt={2}>
                    <form onSubmit={handleSubmit(onSubmit, onFormError)} noValidate>
                      <Box
                        sx={{
                          mx: 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          height: '100%',
                        }}
                      >
                        <TextField
                          size="small"
                          label="Token"
                          className={`autofill_inputlog ${isDark ? 'darkmd' : 'lightmd'}`}
                          type="text"
                          variant="outlined"
                          error={!!errors.token}
                          {...register('token')}
                          fullWidth
                          InputLabelProps={{
                             shrink: !!watch('token'),
                            sx: {
                              color: '#2c2c2c',
                            },
                          }}
                          inputProps={{
                            style: {
                              color: '#2c2c2c',
                            },
                            placeholder: 'Enter your username',
                          }}
                          sx={{
                          mb: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            '& fieldset': {
                              borderColor: '#e2e8f0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#e2e8f0',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#e2e8f0',
                            },
                          },
                          '& .MuiInputLabel-root': {
                            color: '#2c2c2c',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '& .MuiOutlinedInput-input': {
                            color: '#334155',
                          },
                        }}
                        />
                          <TextField
                          size="small"
                          label="Phone Number Id"
                          className={`autofill_inputlog ${isDark ? 'darkmd' : 'lightmd'}`}
                          type="text"
                          variant="outlined"
                          error={!!errors.phoneNumberId}
                          {...register('phoneNumberId')}
                          fullWidth
                          InputLabelProps={{
                            shrink: !!watch('phoneNumberId'),
                            sx: {
                              color: '#2c2c2c',
                            },
                          }}
                          inputProps={{
                            style: {
                              color: '#2c2c2c',
                            },
                            placeholder: 'Enter your username',
                          }}
                          sx={{
                          mb: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            '& fieldset': {
                              borderColor: '#e2e8f0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#e2e8f0',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#e2e8f0',
                            },
                          },
                          '& .MuiInputLabel-root': {
                            color: '#2c2c2c',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '& .MuiOutlinedInput-input': {
                            color: '#334155',
                          },
                        }}
                        />
                        <Box className="modal-btn-voilet">
                          <Button
                            variant="contained"
                            fullWidth
                            bgColor={theme.palette.background.bgpurple}
                            textColor={theme.palette.custom.whitetext}
                            padding="12px 10px"
                            fontSize="16px"
                            disabled={isSubmitting || requestLoading.saveWhatsAppSetting}
                            type="submit"
                            sx={{ width: '100%', fontWeight: 600 }}
                          >
                            {isSubmitting ? 'Sending...' : 'Submit'}
                          </Button>
                        </Box>

                        <Divider
                          sx={{
                            mt: 2,
                             borderColor: '#adadad !important',
                            '& .MuiDivider-wrapper': {
                              fontSize: '13px',
                              fontWeight: 500,
                              color: '#adadad',
                            },
                            '--Divider-childPosition': `${position}%`,
                          }}
                        >
                        
                        </Divider>
                        <Box
                          pt={1}
                          textAlign={'center'}
                          color={'#adadad'}
                          fontSize={13}
                          fontWeight={400}
                        >
                          <Box
                            component={'span'}
                            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                            color="#adadad"
                          >
                            Privacy Notice
                          </Box>{' '}
                          |{' '}
                          <Box
                            component={'span'}
                            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                            color="#adadad"
                          >
                            Term of service
                          </Box>
                        </Box>
                      </Box>
                    </form>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default WhatsAppSetting;
